var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('div',{staticClass:"invite-qrCode"},[_c('vue-qr',{attrs:{"logoSrc":_vm.codeLogoSrc,"text":_vm.inviteQrCodeText,"size":200}})],1),_c('g-copy-right')],1)}
var staticRenderFns = []

export { render, staticRenderFns }